<template>
	<div>
		<div class="clearfix mb-2" v-if="ttevent">
			<div class="float-right text-right">
				<h1 class="mb-0">{{ttevent.checkincode}}</h1>
				<div class="mb-1" v-if="ttevent.checkincode">
					<img
						:src="`${$settings.APIBaseURL}/timetables/events/getqr?ttevent_id=${ttevent.ttevent_id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=sm`"
						style="width: 100px"
						@click="showtoken=true"
					/>
				</div>
				<div>
					<button class="btn btn-success" @click="markAllPresent()" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')
                        || ($UserSession.hasPriv.call(this, 'TIMETABLE_ATTENDANCE') && isEventOngoing)">{{$t('mark-all-present')}}</button>
				</div>
			</div>
			<h1 class="mb-0">{{ttevent.ttsessiontype_name}} {{ttevent.ttroom_name}}</h1>
			<p v-if="ttevent.ttsessiontype_notes" class="mt-0">{{ttevent.ttsessiontype_notes}}</p>
            <p class="mt-0">
                {{ ttevent.ttevent_datetimefrom && ttevent.ttevent_datetimeto
                ? parseDateTime() : '' }}
            </p>
		</div>
		<div class="list-group">
			<div
				class="list-group-item list-group-item-action"
				v-for="(student, index) in students"
				v-bind:key="index"
			>
				<div class="clearfix">
					<Avatar
						class="avatar float-left mr-4 mb-0 lg:mb-0"
						:userId="student.user_id"
					/>
					<div class="float-left mr-4 mb-0">
						<h3 class="mb-0">
							{{ student.displayname }}
						</h3>
						<p class="mb-0">
							{{ student.ttsessiontype_name }}
						</p>
						<p class="mb-0" v-if="student.absencetype_title">
							{{ student.absencetype_title }}
						</p>
					</div>
					<div class="float-right">

						<!--<button
							class="btn btn-success btn-lg ml-2"
							v-if="student.attended === null || !student.attended"
							@click="markHere(student)"
						>
							Here
						</button>
						<button
							class="btn btn-danger btn-lg ml-2"
							v-if="student.attended === null || student.attended"
							@click="markAbsent(student)"
						>
							Absent
						</button>-->

						<div class="btn-group" style="display: block">
							<button
								class="btn btn-on-good"
								v-bind:class="{
									'btn-on': student.attended,
									'btn-off': !student.attended
								}"
								@click="updateAttendance(student, true)"
								:disabled="!student.canChange || !canEditAttendance"
							>
								{{ $t('here') }}
							</button>
							<button
								class="btn btn-on-bad"
								v-bind:class="{
									'btn-on': !student.attended && student.attended !== null,
									'btn-off': student.attended || student.attended === null
								}"
								@click="updateAttendance(student, false)"
								:disabled="!student.canChange || !canEditAttendance"
							>
								{{ $t('absent') }} /
								{{ $t('late') }}
							</button>
						</div>


					</div>
					<!--
					<b-icon icon="check-circle-fill" class="float-right mt-1" v-if="student.attended"></b-icon>
					<b-icon
					icon="x-circle-fill"
					class="float-right mt-1"
					v-if="student.attended !== null && !student.attended"
					></b-icon>
					-->
				</div>
			</div>

			<div class="cafsmodalmask"  v-if="selectedAbsence">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">{{ selectedAbsence.student_displayname }}</h5>
							<button class="btn" @click="selectedAbsence=null">
								<b-icon icon="x"></b-icon>
							</button>
						</div>
						<div class="modal-body">

							<div class="mb-4">
								<h5>{{ $t('type') }}</h5>
								<div>
									<select
										class="form-control"
										v-model="selectedAbsence.type"
									>
										<option value="">{{ $t("please-select") }}</option>
										<option
											v-for="absenceType in absenceTypes"
											:key="absenceType.id"
											:value="absenceType.id"
											>{{ absenceType.title }}</option
										>
									</select>
								</div>
							</div>

							<div class="mb-4">
								<h5>{{ $t("comments") }}</h5>
								<div>
									<textarea
										class="form-control"
										v-model="selectedAbsence.comment"
									></textarea>
								</div>
							</div>

							<div>
								<button
									class="btn btn-primary"
									@click="saveAbsence"
									data-cy="save-absence-button"
								>
									{{ $t("save") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="ttevent" v-show="showtoken" style="background: #FFFFFF; z-index: 20000; position: fixed; top: 0; bottom: 0; left: 0; right: 0; padding: 20px">
			<div class="clearfix">
				<div class="float-right; text-right">
					<a
						class="btn btn-light mr-2"
						download="attendancecode.png"
						:href="`${$settings.APIBaseURL}/timetables/events/getqr?ttevent_id=${ttevent.ttevent_id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=xl&dl=1`"
						title="attendancecode.png"
					>
   				 		{{$t('download')}}
					</a>
					<button class="btn btn-light" @click="closeQRDialog()"><b-icon-x></b-icon-x></button>
				</div>
			</div>
			<div class="text-center">
				<h1 style="font-size: 60px">{{ttevent.checkincode}}</h1>
				<img
					:src="`${$settings.APIBaseURL}/timetables/events/getqr?ttevent_id=${ttevent.ttevent_id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=xl`"
					style="width: 100%; max-width: 525px"
				/>
			</div>
		</div>
	</div>
</template>

<script>
// import MarkAttendance from "../components/MarkAttendance";
// import students from "src/data/students";
import Avatar from "src/components/Avatar.vue";

export default {
	components: {
		Avatar
	},
	data() {
		return {
			ttevent: null,
			students: [],
			manuallySelectedStudent: null,
			selectedAbsence: null,
			showtoken: false,
            now: this.$datetime.getDateTimeLocalFieldNowValue() ,

		};
	},
	mounted() {
		this.getStudents();
	},
	updated() {
		//console.log("updated", this.students, this.selectedStudent);
	},
	methods: {
		getStudents(markallattended=false) {
			this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/geteventregister`, {
				data: {
					'event_id': Number(this.$route.params["eventid"]),
					'mark_all_attended': markallattended
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.ttevent = res.result.ttevent;
					this.students = res.result.students;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		},
		updateAttendance(student , status) {
			if(status == false){
				this.selectedAbsence = {
					student: student,
					student_id: student.user_id,
					student_displayname: student.displayname
				}
			} else {
				if(status !== student.attended){
					this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/saveattendance`, {
						data: {
							'ttevent_id': Number(student.ttevent_id),
							'student_id': student.user_id,
							'status': status,
						},
					}).then((res) => {
						if (res.status === "SUCCESS") {
							student.attended = status;
						} else {
							this.somethingWentWrong();
						}
					}).catch(() => {
						this.somethingWentWrong();
					});
				}
			}
		},
		saveAbsence(){
			this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/saveattendance`, {
				data: {
					'ttevent_id': Number(this.selectedAbsence.student.ttevent_id),
					'student_id': this.selectedAbsence.student_id,
					'status': false ,
					'type': this.selectedAbsence.type ,
					'comment': this.selectedAbsence.comment,
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.selectedAbsence.student.attended = status;
					if(this.selectedAbsence.type){
						this.absenceTypes.forEach(item => {
							if(item.id == this.selectedAbsence.type){
								this.selectedAbsence.student.absencetype_title = item.title
							}
						});
					}
					this.selectedAbsence = null;
				} else {
					this.somethingWentWrong();
				}
			}).catch(() => {
				this.somethingWentWrong();
			});
		},
		closeQRDialog(){
			this.showtoken=false;
			this.getStudents();
		},
		markAllPresent(){
			var self=this;
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("mark-all-present"),
				content: this.$t("mark-all-unchecked-students-as-present-question"),
				confirmCallBack: function() {
					self.getStudents(true);
					/*
					self.getStudents(function(){
						self.students.forEach((student) => {
							if(student.attended === null){
								self.$cfetch(`${self.$settings.APIBaseURL}/timetable/register/saveattendance`, {
									data: {
										'ttevent_id': Number(student.ttevent_id),
										'student_id': student.user_id,
										'status': true
									},
								}).then((res) => {
									if (res.status === "SUCCESS") {
										student.attended = true;
									} else {
										self.somethingWentWrong();
									}
								}).catch(() => {
									self.somethingWentWrong();
								});
							}
						});
					});
					*/
				}
			});

		},
		somethingWentWrong(){
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("oops"),
				content: this.$t("something-went-wrong")
			});
		},
        parseDateTime(){

            const dateFrom = this.$datetime.getLocaleStringFromISODate(this.ttevent.ttevent_datetimefrom);
            const dateTo = this.$datetime.getLocaleStringFromISODate(this.ttevent.ttevent_datetimeto);
            const timeFrom = this.$datetime.isoDateTimeToTime(this.ttevent.ttevent_datetimefrom);
            const timeTo = this.$datetime.isoDateTimeToTime(this.ttevent.ttevent_datetimeto);

            if(dateFrom !== dateTo){
                return `${timeFrom}, ${dateFrom} - ${timeTo}, ${dateTo}`;
            }
            return `${dateFrom} | ${timeFrom} - ${timeTo}`
        }

	},
	computed: {
		selectedStudent() {
			return this.manuallySelectedStudent
				? this.students[this.manuallySelectedStudent].name
				: this.students.find((student) => student.attended === null).name;
		},
		absenceTypes: function() {
			const obj = this.$config.getValue("absencetypes");
			if (obj) {
				return Object.values(this.$config.getValue("absencetypes"));
			}
			return [];
		},
        isEventOngoing(){
            if(this.ttevent){
                const now = new Date();
                const from = new Date(this.ttevent.ttevent_datetimefrom);
                const to = new Date(this.ttevent.ttevent_datetimeto);
                return from.getDate() === now.getDate()
                    || now.getDate() === to.getDate();
            }
            return false;
        },
        canEditAttendance(){
        	return this.$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN') || this.$UserSession.hasPriv('PLACEMENT_MY_PLACEMENTS') || (this.$UserSession.hasPriv.call(this, 'TIMETABLE_ATTENDANCE') && this.isEventOngoing)
        },


	}
};
</script>
